import React from "react";
import { Col, Row, Stack } from "react-bootstrap";
import BedManagementCard from "./BedManagementCard";

interface BedState {
  getItems: any;
  beds: any[];
  setOrgToSave: any;
  setErrMessage: any;
  setShowToast: any;
  setToastText: any;
  setToastBody: any;
}

const BedManagement = ({ getItems, beds, setOrgToSave, setErrMessage, setShowToast, setToastText, setToastBody }: BedState) => {
  return (
    <Row className="mt-3">
      <Col xs={12} xl={10}>
        {beds.length === 0 ? (
          <p className="mt-2">No Beds Created</p>
        ) : (
          <Stack gap={2}>
            {beds?.map((item: any, index: number) => (
              <Row key={index}>
                <Col xs={12}>
                  <BedManagementCard
                    bed={item}
                    getItems={getItems}
                    setOrgToSave={setOrgToSave}
                    setErrMessage={setErrMessage}
                    setShowToast={setShowToast}
                    setToastText={setToastText}
                    setToastBody={setToastBody}
                  />
                </Col>
              </Row>
            ))}
          </Stack>
        )}
      </Col>
    </Row>
  );
};

export default BedManagement;
